import React from "react";
import { Text, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSelector } from "react-redux";
import { Color, globalFontStyle } from "../../../assets";
import Header from "../../../commonComponents/Header";
import AddMoneyDetails from "../childComponents/AddMoneyDetails";
import AddMoneyGST from "../childComponents/AddMoneyGST";
import CryptoNetworkDetails from "../childComponents/CryptoNetworkDetails";
import WithdrawInfo from "./WithdrawInfo";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const WalletAmountReview = ({
  route,
  rechargeDetails,
  confirmDepositClick,
  setEnableReviewScreen = null,
  amount: withdrawAmount,
  isCryptoPayout = false,
}) => {
    const insets = useSafeAreaInsets();
    const rechargeData = route?.params?.rechargeDetails || rechargeDetails;
    const amount = route?.params?.amount || withdrawAmount;
    const isCryptoWithdraw = route?.params?.isCryptoPayout || isCryptoPayout;

    let userInfo = useSelector(({ profile }) => profile?.profileData);
    const region = userInfo?.region_code ?? "INDIA";
    const confirmDepositCallback =
        route?.params?.confirmDepositClick || confirmDepositClick;
    return (
        <View
            style={{
                backgroundColor: globalConfigurableData.globalThemeColor,
                flex: 1,
                paddingTop: insets.top,
                paddingBottom: insets.bottom,
                paddingLeft: insets.left,
                paddingRight: insets.right,
            }}
        >
            <Header
                isInternalPage={false}
                isBackgroundColor={false}
                pageName={amount ? "Review your withdrawal" : "Review your deposit"}
                isBackBtnCallback={setEnableReviewScreen}
                translate={true}
            />
            <View style={{ paddingHorizontal: 15, flex: 1 }}>
                {!amount && region === "INDIA" ? null : (
                    <View>
                        <FormTextLabel
                            labelStyles={[
                                globalFontStyle.appFontSubText,
                                { marginTop: 20, borderColor: globalConfigurableData.quaternaryTextColor1,},
                            ]}
                            label={amount
                                ? !isCryptoWithdraw
                                    ? "Withdraw Details - As per govt regulations, TDS of 30% is applicable on net winnings at the time of withdrawal."
                                    : "Withdraw Details - Please cross check your deposit details before proceeding further."
                                : "Important - Please make sure you send the currency mentioned below, otherwise it might be lost."}
                        />

                        <View
                            style={{
                                borderBottomWidth: 0.2,
                                borderColor: globalConfigurableData.quaternaryTextColor1,
                                marginVertical: 15,
                            }}
                        ></View>
                    </View>
                )}

                {!amount ? (
                    region !== "INDIA" ? (
                        <AddMoneyDetails
                            rechargeDetails={rechargeData}
                            confirmDepositClick={confirmDepositCallback}
                        />
                    ) : (
                        <AddMoneyGST confirmDepositClick={confirmDepositCallback} />
                    )
                ) : isCryptoWithdraw ? (
                    <CryptoNetworkDetails
                        details={rechargeData}
                        withDrawConfirmBtnClick={confirmDepositCallback}
                    />
                ) : (
                    <WithdrawInfo
                        amountToWithdraw={amount}
                        withDrawConfirmBtnClick={confirmDepositCallback}
                    />
                )}
            </View>
        </View>
    );
};
export default WalletAmountReview;
